
import React from 'react';
import { AdminSidebar } from './AdminSidebar';
import { AdminTopbar } from './AdminTopbar';
import { MobileAdminTopbar } from './MobileAdminTopbar';
import { SidebarProvider } from "@/components/ui/sidebar";
import { cn } from '@/lib/utils';
import { useAuth } from '@/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

interface AdminLayoutProps {
  children: React.ReactNode;
}

export const AdminLayout = ({ children }: AdminLayoutProps) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  
  // Check if user has admin permission
  const isAdmin = user && ['admin', 'superadmin'].includes(user.user_metadata?.role || '');
  
  if (!isAdmin) {
    // Redirect non-admins
    setTimeout(() => navigate('/'), 100);
    return (
      <div className="flex h-screen w-full bg-background text-foreground items-center justify-center">
        <div className="flex flex-col items-center space-y-4">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <p>Access denied. Redirecting...</p>
        </div>
      </div>
    );
  }
  
  return (
    <SidebarProvider defaultOpen={!isMobile}>
      <div className="flex h-screen w-full bg-background text-foreground">
        <AdminSidebar />
        <div className="flex flex-col flex-1 overflow-hidden">
          {isMobile ? <MobileAdminTopbar /> : <AdminTopbar />}
          <main className={cn(
            "flex-1 overflow-auto custom-scrollbar scrollbar-thin scrollbar-thumb-border/40 scrollbar-track-transparent hover:scrollbar-thumb-border/60",
            isMobile ? "p-3" : "p-6"
          )}>
            {children}
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
};
